import { useAtomValue } from 'jotai';
import { algorithmVersionAtom } from './jotaiAtoms';

function useFeedFrameFilter(overrides = {}) {
  const defaultFilter = {
    deleted_at: { _is_null: true },
  };

  return { ...defaultFilter, ...overrides };
}

function useAnalysisFilter(overrides = {}) {
  const algorithmVersion = useAtomValue(algorithmVersionAtom);

  const defaultFilter = {
    deleted_at: { _is_null: true },
  };
  if (algorithmVersion) {
    defaultFilter.algorithm_version = { _eq: algorithmVersion };
  } else {
    defaultFilter.is_current_algorithm_version = { _eq: true };
  }

  return { ...defaultFilter, ...overrides };
}

export { useFeedFrameFilter, useAnalysisFilter };
